module.exports = __webpack_public_path__ + "static/program-cf400b516fe93e6e1245d68fcf552c60.svg";